<template>
  <a-range-picker
    :value="dateRange"
    @change="onDateRangeChange"
    :disabledDate="disabledDate"
    format="YYYY-MM-DD"
  />
</template>

<script>
import moment from "moment";

export default {
  name: "DateRangePicker",
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    dateRange() {
      return [moment(this.value.start), moment(this.value.end)];
    }
  },
  methods: {
    onDateRangeChange(dates, dateStrings) {
      this.$emit("input", {
        start: dates[0].toDate(),
        end: dates[1].toDate()
      });
    },
    disabledDate(current) {
      return current && current > moment().endOf("day");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/kitchen/date-range-picker.vue